<template>
<div>
    <b-card title="REPORTES DE RECARGAS">
        <b-row>
            <b-col md="3">
                <br>
                <label for="Fecha">Fecha Inicial</label>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="date" required v-model="fecha_ini"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col md="3">
                <br>
                <label for="Fecha">Fecha Final</label>
                <b-input-group>
                    <b-input-group-prepend>
                        <b-input-group-text><i class="fa fa-calendar"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input type="date" required v-model="fecha_fin"></b-form-input>
                </b-input-group>
            </b-col>
            <b-col md="1">
                <br>
                <br>
                <b-button variant="success" @click="consultar">Buscar</b-button>
            </b-col>
        </b-row>
    </b-card>
    <b-row>
        <b-col md="12">
            <br>
            <List :showbtn='false' :mapState="'adminCarnets'" v-if='show_tbl' :allDispatch="'adminCarnetsReportsAux'" :excelFooter="footer" :excelHead="head" :exportExcel='true' nameFileExcel='ReportesCarnets.xls'></List>
        </b-col>
    </b-row>

</div>
</template>

<script>
import List from '@/components/modules/base/list.vue'
import {
    getCurrentDate,
    getDate
} from '@/api'
const head = {
    'Fecha	': 'created_at',
    'Funcionario': 'funcionario',
    'A Usuario	': 'usuario',
    'No. documento	': 'num_doc',
    'Acudiente' : 'acudiente',
    'Documento acudiente': 'num_doc_acudiente',
    'Credencial recargada': 'code',
    'Saldo previo	': 'saldo_previo',
    'Recarga': 'recarga',
    'Nuevo saldo': 'saldo_nuevo'
}
export default {
    name: 'Lists',
    components: {
        List
    },
    data() {
        return {
            fecha_fin: getCurrentDate(),
            fecha_ini: getDate('01/01/2018'),
            show_tbl: false,
            head: head,
            total: 0,
            footer: ''
        }
    },
    created() {
        this.head['Totalll']
    },
    methods: {
        consultar() {
            this.show_tbl = false
            let data = {
                'fecha_ini': this.fecha_ini + ' 00:00:00',
                'fecha_fin': this.fecha_fin + ' 23:59:00'
            }
            let total = 0
            this.$store.dispatch('adminCarnetsReportsAll', data).then(Response => {
                if (this.$store.getters.adminCarnets.items.length > 0) {
                    this.show_tbl = true
                    let item = this.$store.getters.adminCarnets.items
                    item.forEach(element => {
                        total += Number(element.recarga)
                        this.footer = 'TOTAL RECARGAS ' + total
                    });
                } else {
                    this.$root.showInfoDialog('Mensaje informativo', 'No se encontraron registros para la consulta', 'Aceptar')
                    this.show_tbl = false
                }

            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/carnets/reports.vue